export const TRANSLATION_SCOPE = 'patientModule';
export const TRANSLATION_CRUD_SCOPE = [TRANSLATION_SCOPE, 'crud'];
